/**
 * Tax Year Display Formatter
 *
 * Single source of truth for tax-year display formatting in the frontend.
 * Compresses fiscal-range tax years from `YYYY/YYYY` to `YYYY/YY` to prevent
 * column overflow in tables.
 *
 * Examples:
 *   "2025"          -> "2025"
 *   "2025/2026"     -> "2025/26"
 *   "2025/2026-1"   -> "2025/26-1"
 *   "2025-1"        -> "2025-1"
 *   "2025/26"       -> "2025/26"  (already short — left unchanged)
 *   ""              -> ""
 *   null/undefined  -> ""
 *
 * The DB-stored value is never modified. Use this only at render/output sites.
 */

const FISCAL_RANGE_RE = /^(\d{4})\/(\d{4})(.*)$/;

export function formatTaxYear(value) {
  if (value === null || value === undefined) return '';
  const text = String(value).trim();
  if (!text) return '';

  const match = text.match(FISCAL_RANGE_RE);
  if (!match) return text;

  const [, firstYear, secondYear, rest] = match;
  const shortSecond = secondYear.slice(-2);
  return `${firstYear}/${shortSecond}${rest}`;
}

export default formatTaxYear;
